export const isFulfilledRequestStatus = (response) => response?.meta?.requestStatus === 'fulfilled';
